import { render, staticRenderFns } from "./MediaManagementMobile.vue?vue&type=template&id=05aba67c&scoped=true&"
import script from "./MediaManagementMobile.vue?vue&type=script&lang=js&"
export * from "./MediaManagementMobile.vue?vue&type=script&lang=js&"
import style0 from "./MediaManagementMobile.vue?vue&type=style&index=0&id=05aba67c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aba67c",
  null
  
)

export default component.exports